export function mouseOverAtom(state) {
  return (
    state.mouse.lastMove &&
    state.mouse.lastMove.atom &&
    state.mols[state.mouse.molIndex].atoms[state.mouse.lastMove.idx]
  );
}

export function mouseOverBond(state) {
  return (
    state.mouse.lastMove &&
    state.mouse.lastMove.bond &&
    state.mols[state.mouse.molIndex].bonds[state.mouse.lastMove.idx]
  );
}

export function mouseOverEmptySpace(state) {
  return state.mouse.lastMove && state.mouse.lastMove.empty;
}
